<div class="detailpage-list-item" *ngIf="value">
  <label>
    {{label}}
  </label>
  <div class="value">
    {{value}}
  </div>
</div>
